const setStaticSearches = (context, object) => {
  context.commit("SEARCH_STATIC_UPDATED", object);
};

// BE AWARE! Using setFavoriteStaticSearches will result in recursive errors!
// TODO find the cause for the recursive error
const setFavoriteStaticSearches = (context, object) => {
  context.commit("FAVORITE_SEARCH_STATIC_UPDATED", object);
};

const setActiveWorkCollapsePanels = (context, arrayOfActivePanels) => {
  localStorage.setItem("dashboard-work-active-collapse-panels", JSON.stringify(arrayOfActivePanels));
  context.commit("SET_ACTIVE_WORK_COLLAPSE_PANELS", arrayOfActivePanels);
};

const initialiseStore = (context) => {
  context.commit("INITIALISE_STORE");
};

export default {
  setStaticSearches,
  setFavoriteStaticSearches,
  setActiveWorkCollapsePanels,
  initialiseStore,
};
